export const SUPPORTED_COUNTRY_CODES = ['+55', '+54'] as const;
export const SUPPORTED_SERVER_COUNTRIES = ['br', 'ar'] as const;

export type CountryCode = (typeof SUPPORTED_COUNTRY_CODES)[number];
export type ServerCountry = (typeof SUPPORTED_SERVER_COUNTRIES)[number];

export const DEFAULT_COUNTRY_CODE: CountryCode = '+55';

const PHONE_COUNTRY_CODE_BY_SERVER_COUNTRY: Record<ServerCountry, CountryCode> =
  {
    ar: '+54',
    br: '+55',
  };

export function isCountryCode(value: string): value is CountryCode {
  return SUPPORTED_COUNTRY_CODES.includes(value as CountryCode);
}

export function isServerCountry(value: string): value is ServerCountry {
  return SUPPORTED_SERVER_COUNTRIES.includes(value as ServerCountry);
}

export function resolvePhoneCountryCode(
  value: string | null | undefined,
): CountryCode {
  if (typeof value !== 'string') {
    return DEFAULT_COUNTRY_CODE;
  }

  const normalizedValue = value.trim().toLowerCase();

  if (isCountryCode(normalizedValue)) {
    return normalizedValue;
  }

  if (isServerCountry(normalizedValue)) {
    return PHONE_COUNTRY_CODE_BY_SERVER_COUNTRY[normalizedValue];
  }

  return DEFAULT_COUNTRY_CODE;
}
